function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import Mask from "../mask";
import { Slide } from "./slide";
import { Slides } from "./slides";
import SafeArea from "../safe-area";
import { mergeProps } from "../../utils/mergeProps";
import { renderToContainer } from "../../utils/render-to-container";
var classPrefix = "tc-image-viewer";
var ImageViewer = function ImageViewer(props) {
  var _props$maxZoom = props.maxZoom,
    maxZoom = _props$maxZoom === void 0 ? 3 : _props$maxZoom,
    _props$getContainer = props.getContainer,
    getContainer = _props$getContainer === void 0 ? null : _props$getContainer,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    image = props.image,
    afterClose = props.afterClose,
    onClose = props.onClose,
    renderFooter = props.renderFooter;
  var node = /*#__PURE__*/React.createElement(Mask, {
    visible: visible,
    disableBodyScroll: false,
    afterClose: afterClose,
    destroyOnClose: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, image && /*#__PURE__*/React.createElement(Slide, {
    image: image,
    onTap: function onTap() {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    maxZoom: maxZoom
  })), image && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-footer")
  }, renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter(image), /*#__PURE__*/React.createElement(SafeArea, {
    position: 'bottom'
  })));
  return renderToContainer(getContainer, node);
};
var multiDefaultProps = {
  maxZoom: 3,
  getContainer: null,
  visible: false,
  defaultIndex: 0
};
export var MultiImageViewer = /*#__PURE__*/forwardRef(function (p, ref) {
  var props = mergeProps(multiDefaultProps, p);
  var onIndexChange = props.onIndexChange,
    visible = props.visible,
    afterClose = props.afterClose,
    maxZoom = props.maxZoom,
    images = props.images,
    renderFooter = props.renderFooter,
    getContainer = props.getContainer,
    defaultIndex = props.defaultIndex,
    onClose = props.onClose;
  var _useState = useState(defaultIndex),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var slidesRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      swipeTo: function swipeTo(idx, immediate) {
        var _a;
        setIndex(idx);
        (_a = slidesRef.current) === null || _a === void 0 ? void 0 : _a.swipeTo(idx, immediate);
      }
    };
  });
  var onSlideChange = useCallback(function (idx) {
    setIndex(idx);
    onIndexChange === null || onIndexChange === void 0 ? void 0 : onIndexChange(idx);
  }, [onIndexChange]);
  var node = /*#__PURE__*/React.createElement(Mask, {
    visible: visible,
    disableBodyScroll: false,
    afterClose: afterClose,
    destroyOnClose: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-content")
  }, images && /*#__PURE__*/React.createElement(Slides, {
    ref: slidesRef,
    defaultIndex: index,
    onIndexChange: onSlideChange,
    images: images,
    onTap: function onTap() {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    },
    maxZoom: maxZoom
  })), images && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-footer")
  }, renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter(images[index], index), /*#__PURE__*/React.createElement(SafeArea, {
    position: 'bottom'
  })));
  return renderToContainer(getContainer, node);
});
export default ImageViewer;